// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XOkZ","col":"styles_col__2yQVU"};